/**
 * Collection Section
 * Product grid (CollectionProducts) plus optional filter-card quick-filters.
 */

import CollectionProducts from '../snippets/collection-products';
import FilterCards from '../snippets/filter-cards';

export default class Collection {
  constructor(container) {
    this.container = container;
    this.products = new CollectionProducts(container);
    new FilterCards(container, this.products);
  }
}
